import '../frontend.scss';

import fixedHeader from './modules/fixedHeader.js';
import effects from './modules/effects.js';
import nav from './modules/nav.js';
import blogFilter from './modules/blogFilter.js';
import code from './modules/code.js';
import projectModal from './modules/projectModal.js';
import projectFilter from './modules/projectFilter.js';
import lightbox from './modules/lightbox.js';
import formMasks from './modules/formMasks.js';
import accordion from './modules/accordion.js';
import tableScroll from './modules/tableScroll.js';
import priceCalculator from './modules/priceCalculator.js';
import cookieBanner from './modules/cookieBanner.js';
import shareCopy from './modules/shareCopy.js';

document.addEventListener('DOMContentLoaded', () => {
  fixedHeader();
  effects();
  nav();
  blogFilter();
  code();
  projectModal();
  projectFilter();
  lightbox();
  formMasks();
  accordion();
  tableScroll();
  priceCalculator();
  cookieBanner();
  shareCopy();
});

